import React from "react";
import {
    Navigate,
} from "react-router-dom";

const RecurrenceListComponent = React.lazy(() => import("../../../../../components/stk-recurrence/components/list/page"));
const RecurrenceAddComponent = React.lazy(() => import("../../../../../components/stk-recurrence/components/add/page"));

export const recurrenceRoutes = [
    {
        path: 'list',
        element: <RecurrenceListComponent />
    },
    {
        path: 'add',
        element: <RecurrenceAddComponent />
    },
    {
        path: 'edit',
        element: <Navigate to="/stockify/recurrence/add" />
    },
    {
        path: 'edit/:id',
        element: <RecurrenceAddComponent />
    },
    {
        path: '',
        element: <Navigate replace to="/stockify/recurrence/list" />
    },
];